export const RECEIVE_APPS_FLYERS_INFO = "received_apps_flyer_info";
